const TOLERANCE = 8;

export default function calcStaggeredLeft(slider: HTMLDivElement, count: number) {
  // Get all child items
  const items = getItemsFromSlider(slider);
  const gap = calcGap(slider);

  // Find current position
  const scrollLeft = slider.scrollLeft;
  const scrolledItemIndex = getScrolledItemIndex(items, scrollLeft, gap);

  // Calculate the target position
  const targetItemIndex = getTargetItemIndex(items, scrolledItemIndex, count);
  return calcTargetItemLeft(items, targetItemIndex, gap);
}

function getItemsFromSlider(slider: HTMLDivElement) {
  const children = slider.querySelector('.items-container')?.children ?? [];
  return Array.from(children) as HTMLElement[];
}

function calcGap(slider: HTMLDivElement): number {
  // Assume there is a parent container (e.g. ".items-container") with "gap" or "columnGap"
  const container = slider.querySelector<HTMLElement>('.items-container');
  if (!container) {
    return 0;
  }

  const gap = parseFloat(window.getComputedStyle(container).gap) ?? 0;
  return !isNaN(gap) ? gap : 0;
}

function getScrolledItemIndex(items: HTMLElement[], scrollLeft: number, gap: number) {
  let scrolledItemIndex = 0;
  let totalWidth = 0;
  while (totalWidth + TOLERANCE <= scrollLeft && scrolledItemIndex < items.length) {
    totalWidth += items[scrolledItemIndex].offsetWidth + gap;
    scrolledItemIndex++;
  }
  return scrolledItemIndex;
}

function getTargetItemIndex(items: HTMLElement[], scrolledItemIndex: number, count: number) {
  return Math.min(Math.max(0, scrolledItemIndex + count), items.length - 1);
}

function calcTargetItemLeft(items: HTMLElement[], targetItemIndex: number, gap: number) {
  return items.slice(0, targetItemIndex).reduce((acc, item) => acc + item.offsetWidth + gap, 0);
}
